/* Harna Pilates — theme behaviour */
(function () {
  'use strict';

  /* ---- mobile nav drawer ---- */
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- founding member form: plan choice ---- */
  var planInput = document.getElementById('plan-value');
  var planButtons = Array.prototype.slice.call(document.querySelectorAll('[data-plan-option]'));

  function selectPlan(value) {
    if (!planInput) return;
    planInput.value = value;
    planButtons.forEach(function (btn) {
      var on = btn.getAttribute('data-plan-option') === value;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  planButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectPlan(btn.getAttribute('data-plan-option'));
    });
  });

  /* ---- pricing card CTAs preselect a plan, then scroll to the form ---- */
  document.querySelectorAll('[data-pick-plan]').forEach(function (link) {
    link.addEventListener('click', function () {
      selectPlan(link.getAttribute('data-pick-plan'));
    });
  });

  /* ---- founding member form: class time chips (multi-select) ---- */
  var timesInput = document.getElementById('times-value');
  var chips = Array.prototype.slice.call(document.querySelectorAll('[data-time-option]'));

  function syncTimes() {
    if (!timesInput) return;
    timesInput.value = chips
      .filter(function (c) { return c.classList.contains('is-selected'); })
      .map(function (c) { return c.getAttribute('data-time-option'); })
      .join(', ');
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var on = chip.classList.toggle('is-selected');
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      syncTimes();
    });
  });

  /* ---- land on the form after a successful post ---- */
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    var reserve = document.getElementById('reserve');
    if (reserve) reserve.scrollIntoView({ block: 'center' });
  }
})();
